import React from "react";
import { Link } from "react-router-dom";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "What do I get with the Pro plan?",
    a: "Everything you need to learn smarter. Unlimited uploads, AI chats, quiz generation, and practice exams. Plus, you can upload files up to 2000 pages or 300 MB.",
  },
  {
    q: "What do I get with the Team plan?",
    a: "Everything in Pro plus team collaboration features. Discounts scale with team size, shared spaces, centralized team billing, and custom permissions.",
  },
  {
    q: "What are the limits for different plans?",
    a: (
      <>
        Limits depend on the content type (PDFs, recordings, voice, etc.) and your plan. You can view a full breakdown
        here.{" "}
        <Link to="/limits" className="inline-flex items-center text-primary font-medium hover:underline">
          View plan limits →
        </Link>
      </>
    ),
  },
  {
    q: "What payment methods do you offer?",
    a: "All major cards supported including Visa, Mastercard, American Express, and Mada for Saudi Arabia.",
  },
  {
    q: "Can I cancel my Shattara AI plan at any time?",
    a: "Yes, you can cancel your subscription at any time. We offer a 14-day money-back guarantee if you're not satisfied.",
  },
  {
    q: "Do you offer student discount?",
    a: "Student pricing coming soon. We're working on special educational pricing for verified students and institutions.",
  },
  {
    q: "What is your refund policy?",
    a: "We offer a 14-day money-back guarantee. If you're not satisfied with your subscription, you can request a full refund within 14 days of purchase.",
  },
];

export const PricingFAQ = () => {
  return (
    <div className="flex flex-col py-12">
      <h1 className="hidden text-center text-2xl font-normal lg:block">Frequently Asked Questions</h1>
      <h1 className="block text-center text-2xl font-normal lg:hidden">FAQs</h1>
      <span className="mb-10 mt-4 text-center text-muted-foreground lg:mb-12">
        Can't find the answer here? &nbsp;
        <a
          className="underline decoration-primary/50 text-foreground hover:text-primary hover:decoration-primary transition-all duration-300 underline-offset-4"
          href="mailto:hello@shattaraai.com"
        >
          Contact us
        </a>
      </span>

      <div className="container mx-auto max-w-[900px] px-4">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border-b -mt-2 mb-3 font-normal leading-loose opacity-90"
            >
              <AccordionTrigger className="flex flex-1 items-center justify-between py-4 transition-all [&[data-state=open]>svg]:rotate-[-90deg] text-lg font-normal hover:no-underline hover:text-primary">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground pb-4">{faq.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};
